// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3H23V18H13V20H17V22H7V20H11V18H1V3Z"}}]};

const DesktopFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'desktop-filled',
    ref,
    icon: element,
  },
));

DesktopFilledIcon.displayName = 'DesktopFilledIcon';

export default DesktopFilledIcon;
